module.exports = __webpack_public_path__ + "03_short_black.09a9f51e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/03_short_black.png
// module id = oT2i
// module chunks = 0